import React from 'react';
import '../App.css';

// Imágenes galería
import instagran01 from '../img/Instagram/campaña-solidaria.jpg';


// Ícono Instagram
import instagram from '../img/instagram-icon.png';

class InstagramGallery extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            photos: [
                
     
                
                {
                    url: 'https://www.instagram.com/p/DbGYkurxd6j/',
                    imageUrl: instagran01,
                },
            ],
        };
    }

    handleIconClick = (icon) => {
        console.log(`Click en ${icon}`);
    };

    render() {
        const { photos } = this.state;

        return (
            <div className="Instagram-Galleria" id="Instagram-list">

                <h2 className="galeria-title">Galería Instagram</h2>

                {/* 🔥 ICONO INSTAGRAM ANIMADO */}
                <div className="instagram-container">
                    <a
                        href="https://www.instagram.com/nuevazelandiaescuela/"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => this.handleIconClick('instagram')}
                    >
                        <img
                            src={instagram}
                            alt="Instagram"
                            className="instagram-icon"
                        />
                    </a>
                </div>

                <div className="photos-list">
                    <div className="photo-cards">
                        {photos.map((photo, index) => (
                            <div
                                key={index}
                                className="photo-card"
                                style={{
                                    backgroundImage: `url(${photo.imageUrl})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                }}
                            >
                                <a
                                    href={photo.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="photo-link"
                                >
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default InstagramGallery;